module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre23"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("This one is for you, Laura O’Connor,")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("My smart and beautiful niece.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("In many ways Billy reminds me of you;")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Determined, hard-working, and blessed with a kind and loving heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Love you!")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre24"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v("As always, thank you to illustrator Faythe Payol")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre24"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v(" who does such a fantastic job of bringing my")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre24"
  }, [_c('span', {
    staticClass: "calibre8"
  }, [_vm._v("books to life.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre22"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54559bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0002.vue
// module id = 66
// module chunks = 0